import type { WorkflowStep } from '../content';

export function WorkflowSection({ steps }: { steps: WorkflowStep[] }) {
  return (
    <section id="workflow" className="workflow-section">
      <div className="section-inner">
        <div className="section-heading">
          <p className="eyebrow">Launch without the scramble</p>
          <h2>Give every campaign a calm, visible path from idea to result.</h2>
          <p>Teams should not need a spreadsheet, a developer, and three dashboards just to answer whether a promotion is ready.</p>
        </div>
        <div className="workflow-rail">
          {steps.map((step) => (
            <article className="workflow-step" key={step.label}>
              <span>{step.label}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
